import React, { Suspense } from 'react';
import useMedia from 'hooks/useMedia';

import Message from 'components/base/Message/Message';
import Layout from 'components/styled/Layout/Layout';
import PositionsTableSkeleton from 'components/data-containers/PositionsTable/SkeletonLoader';

import { CompareModes } from 'context/entityContext';
import { TopicFilterNames } from 'components/TopicFilters/shared';

const CurrentPositionsTable = React.lazy(
  () =>
    import(
      'components/data-containers/PositionsTable/CurrentPositionsTable'
    ) as any
);

const PeakPositionsTable = React.lazy(
  () =>
    import(
      'components/data-containers/PositionsTable/PeakPositionsTable'
    ) as any
);

interface IRadioChartsProps {
  compareMode?: CompareModes;
}

const allowedFilters: TopicFilterNames[] = ['country'];
const chartType = 'airplay';

const RadioCharts: React.FC<IRadioChartsProps> = (props) => {
  const { compareMode } = props;
  const isLargeScreen = useMedia('(min-width: 60em)');
  const isCompare = Boolean(compareMode);

  if (isCompare) {
    return (
      <Layout.MaxWidth>
        <Message>
          Unfortunately there are no other components available in compare mode
          on this topic for tracks.
        </Message>
      </Layout.MaxWidth>
    );
  }

  return (
    // Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components.
    <div>
      <Suspense
        fallback={
          <PositionsTableSkeleton
            title="Chart Positions"
            productType="track"
            variation="currentPosition"
            short
          />
        }
      >
        <CurrentPositionsTable
          productType="track"
          title="Chart Positions"
          allowedFilters={allowedFilters}
          glossarySlug="charts-graphs-tables/position-table"
          chartType={chartType}
          short
        />
      </Suspense>

      <Suspense
        fallback={
          <PositionsTableSkeleton
            title={`Peak Positions${isLargeScreen ? ' by Country' : ''}`}
            productType="track"
            variation="currentPosition"
          />
        }
      >
        <PeakPositionsTable
          productType="track"
          title={`Peak Positions${isLargeScreen ? ' by Country' : ''}`}
          allowedFilters={allowedFilters}
          glossarySlug="charts-graphs-tables/position-table"
          chartType={chartType}
        />
      </Suspense>
    </div>
  );
};

export default RadioCharts;
